import Institutions from "@components/industry/Institutions";
import { renderComponent } from "./page_actions";

const industryInstitution = () => {
  renderComponent(Institutions);
};

export default industryInstitution;
